import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const forgotPassword = async (email) => {
  const response = await axios.post(`${apiUrl}/password/forgot-password`, {
    email,
  });

  return response.data;
};

export const checkResetPasswordToken = async (token) => {
  const response = await axios.get(
    `${apiUrl}/password/check-token/${encodeURIComponent(token)}`
  );

  return response.data;
};

export const resetPassword = async (token, password) => {
  const response = await axios.post(
    `${apiUrl}/password/reset-password/${encodeURIComponent(token)}`,
    {
      password,
    }
  );

  return response.data;
};